/** 
 * Copyright 2021 AEKI <admin@aeki.dev>
 * 
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential 
 */
const SANITIZER = 'sanitizer'
export default SANITIZER

/**
 * Set value to a phone number format
 */
export const phone = () => {
  /**
   * @param value to be normalized as a phone number
   */
  const phone = (value: string) => {
    if (!value) {
      return value
    }

    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums.length <= 3) {
      return onlyNums
    }
    if (onlyNums.length <= 7) {
      return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
    }
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`
  }
  phone.type = SANITIZER

  return phone
}

/**
 * Set value to a time format (hh:mm)
 */
export const time = () => {
  /**
   * @param value to be normalized as time (hh:mm)
   */
  const callback = (value: string) => {
    if (!value) {
      return value
    }

    const onlyNums = value.replace(/[^\d]/g, '')
    if (onlyNums.length <= 2) {
      return onlyNums
    }

    if (onlyNums.length <= 4) {
      return `${onlyNums.slice(0, 2)}:${onlyNums.slice(2)}`
    }
  }
  callback.type = SANITIZER

  return callback
}

/**
 * Remove trailing spaces
 */
export const trim = () => {
  /**
   *
   * @param value to be trimmed
   */
  const callback = (value: string) => {
    return value.trim()
  }
  callback.type = SANITIZER

  return callback
}
